import { String } from '../utilidades/Extensions/string-extensions';

export class DownloadModel {
    id: number;
    name: string;
    url: string;

    constructor(id: number, name: string = String.empty, url: string = String.empty) {
        this.id = id;
        this.name = name;
        this.url = url;
    }
}